import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { colors } from '@soluto-private/mx-asurion-ui-react';

const Container = styled.div`
  display: flex;
  width: 56px;
  height: 56px;

  min-width: 56px;
  min-height: 56px;

  border-radius: 50%;
  background: ${colors.neutralBrightest};
`;

const IconContainer = styled.div`
  margin: auto;
  width: 48px;
  height: 48px;
`;

export const IconWrapper = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Container>
      <IconContainer>{children}</IconContainer>
    </Container>
  );
};
